/* -------------------------------------------------------------------------- */
/*                                Breadcrumb styles                */
/* -------------------------------------------------------------------------- */

:host {
  @apply block;
}
